import { useDispatch } from "react-redux";
import Xarrow from "react-xarrows";
import { importFromYaml } from "../../../../abstract/controller/modelYamlImport";
import * as tutorialUtils from "../../../../abstract/controller/utils/tutorialUtils";
import { useArrowSync } from "../../../../abstract/hook/useArrowSync";
import { setRoot } from "../../../../abstract/redux/slice/structureSlice";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import styles from "./Manual.module.scss";

const id = "struct5";
const idNext = "struct6";
const idPrev = "struct4";

const next = `
global parameters:
  - parameter: character
    parameters:
      - parameter: weapon
        choices:
          - choice: dagger
          - choice: ranged
            choices:
              - choice: bow
              - choice: crossbow
          - choice: melee
            choices:
              - choice: axe
              - choice: mace
              - choice: sword
      - parameter: name
        choices:
          - choice: hero
            choices:
              - choice: Peter
              - choice: Susan
              - choice: Edmund
              - choice: Lucy
          - choice: foe
            choices:
              - choice: witch
              - choice: cyclops
              - choice: giant
    logic:
      - constraint: Girls use daggers
        expression: IF 'character::name' IN ['Susan', 'Lucy'] THEN 'character::weapon' IS 'dagger'
functions:
  - function: simple
    parameters:
      - parameter: location
        choices:
          - choice: forest
          - choice: castle
          - choice: mountain
          - choice: river
          - choice: lake
`;

const prev = `
global parameters:
  - parameter: weapon
    choices:
      - choice: dagger
      - choice: ranged
        choices:
          - choice: bow
          - choice: crossbow
      - choice: melee
        choices:
          - choice: axe
          - choice: mace
          - choice: sword
  - parameter: name
    choices:
      - choice: hero
        choices:
          - choice: Peter
          - choice: Susan
          - choice: Edmund
          - choice: Lucy
      - choice: foe
        choices:
          - choice: witch
          - choice: cyclops
          - choice: giant
functions:
  - function: simple
    parameters:
      - parameter: location
        choices:
          - choice: forest
          - choice: castle
          - choice: mountain
          - choice: river
          - choice: lake
`;

function ManualStructures5({ tutorial, setTutorial }) {
  if (tutorial === id) {
    return <Core setTutorial={setTutorial} />;
  }

  return null;
}

function Core({ setTutorial }) {
  const _dispatch = useDispatch();
  const renderTrigger = useArrowSync();

  const handleShowMe = () => {
    const { model } = importFromYaml(next);
    _dispatch(setRoot(model, 0));
  };

  const handleBack = () => {
    const { model } = importFromYaml(prev);
    _dispatch(setRoot(model, 0));
    setTutorial(idPrev);
  };

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      {document.getElementById("header_globals") &&
        !document.getElementById("add_global_parameter") && (
          <div className={`${styles["container"]} ${styles["container-st5"]} ${styles["overlay"]}`}>
            <div id="tutorial-text-st5" className={`${styles["container__text"]}`}>
              <p>To show/hide global parameters click on the header.</p>
            </div>

            <Xarrow
              key={`arrow-1-${renderTrigger}`}
              start="tutorial-text-st5"
              end="header_globals"
              color="#415B32"
              strokeWidth={2}
              path="smooth"
              curveness={0.8}
              headSize={6}
            />
          </div>
        )}

      <div className={`${styles["foreground"]} ${styles["foreground-st5"]}  ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              Structures can also contain logic nodes! Expand the <b>logic</b> section and add a new
              constraint.
            </p>
            <p>
              Name it <b>Girls use daggers</b> and enter the following expression:{" "}
              <b>IF 'character::name' IN ['Susan', 'Lucy'] THEN 'character::weapon' IS 'dagger'</b>.
            </p>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="red" title="Go back!" onClick={handleBack} />
          </div>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="tomato" title="Show me!" onClick={handleShowMe} />
          </div>
        </div>
      </div>
    </>
  );
}

export const manualValidateStructures5 = (root, tutorial, setTutorial, setMessage) => {
  if (tutorial === id) {
    let { res: resFun, msg: msgFun } = tutorialUtils.validateSingleFunction(root);

    if (!resFun) {
      setMessage(msgFun);
      return false;
    }

    let { res: resLogic, msg: msgLogic } = tutorialUtils.validateCondition(
      root,
      "root→[parameter]→character→[logic]→Girls use daggers",
      "IF 'character::name' IN ['Susan', 'Lucy'] THEN 'character::weapon' IS 'dagger'",
    );

    if (!resLogic) {
      setMessage(msgLogic);
      return false;
    }

    setTutorial(idNext);

    setMessage("");
    return true;
  }

  return false;
};

export default ManualStructures5;
